import { useAuth } from "@via/hooks/useAuth.tsx";
import { useCallback, useEffect, useState, type JSX } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useGetInvitationCheck,
  useInviteExistingUserToOrganization,
} from "@via/pages/organization/organization.api.tsx";
import Login from "@via/pages/authentication/login";
import { LogoSpinner } from "@via/components/loading/loading";
import { GenericError } from "@via/components/error";
import { ERROR } from "@via/utils/constants";

export default function SelfSignIn(): JSX.Element {
  const { user } = useAuth();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [hasInvited, setHasInvited] = useState(false);

  const {
    data: invitationDetails,
    isLoading,
    isSuccess,
    isError,
  } = useGetInvitationCheck(token);

  const { mutate: inviteExistingUserToOrganization } =
    useInviteExistingUserToOrganization();

  const onSuccess = useCallback(() => {
    if (hasInvited) {
      return;
    } else {
      setHasInvited(true);
    }
    inviteExistingUserToOrganization({
      token: token || "",
    });
  }, []);

  useEffect(() => {
    if (user && user?.session) {
      onSuccess();
    }
  }, [user?.id]);

  return (
    <>
      {isLoading && (
        <div className="via-loading-spinner">
          <LogoSpinner />
        </div>
      )}
      {isError && (
        <div className="via-generic-error">
          <GenericError message={ERROR} />
        </div>
      )}
      {isSuccess && (
        <Login
          selfSignIn
          email={invitationDetails?.invitedEmail || ""}
          organizationName={invitationDetails?.organizationName || ""}
          token={token || ""}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
}
